import { useEffect, useState } from 'react';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { AvatarBlock } from "./AvatarBlock";
import { useSelector } from "react-redux";

export const GroupPanel = () => {
  const isMobile = useSelector(state => state.app.isMobile)
  const group = useSelector(state => state.user.group);
  const lang = useSelector(state => state.app.currentLang);

  const [disabledUsers, setDisabledUsers] = useState([])
  const swiperWight = isMobile ? 4 : 6;

  useEffect(() => {
    if (Array.isArray(group)) {
      setDisabledUsers(group
        .filter((user) => {
          if (user.isActive === false) {
            return true
          } else {
            return false
          }
        })
        .map((user) => {
          return user.name;
        }));
    }
  }, [group])

  if (group.length > swiperWight) return (
    <div className="topPanel">
      <Swiper
        spaceBetween={0}
        slidesPerView={swiperWight - 0.3}
        loop={false}
        pagination={{ clickable: false }}
        freeMode={true}
        modules={[Scrollbar]}
        allowTouchMove={true}
        scrollbar={{
          hide: false,
        }}
      >
        <div className="topPanel__group topPanel__group_swiper">
          {
            group.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <AvatarBlock item={item} className="topPanel" groupItem={true} />
                </SwiperSlide>
              )
            })
          }
        </div>
      </Swiper>
      {disabledUsers.length > 0 &&
        <div className="topPanel__errorBanner">
          {lang.games15}
          <span>{
            disabledUsers.join(", ")
          }</span>
          {lang.games16}
        </div>
      }
    </div>
  )
  return (
    <div className="topPanel">
      <div className="topPanel__group">
        {
          group.map((item, index) => {
            return (
              <AvatarBlock item={item} key={index} className="topPanel" groupItem={true} />
            )
          })
        }
      </div>
      {disabledUsers.length > 0 &&
        <div className="topPanel__errorBanner">
          {lang.games15}
          <span>{
            disabledUsers.join(", ")
          }</span>
          {lang.games16}
        </div>
      }
    </div>
  )
}